module.exports = __webpack_public_path__ + "img/NFT_dis.b8dc1ba9.png";